import { ALL_PROVIDERS, CIProvider } from "../types";

export const getCIProvider = (provider: string): CIProvider | undefined => {
  if (ALL_PROVIDERS.find((p) => p === provider)) {
    return provider as CIProvider;
  }
  return undefined;
};
